import { FlowComponentDefinition } from "../../interface/functionalityInterface";
import { OUTLINE_COLOR, renderStraightArrow, renderStraightPulse } from "./renderingUtils";

export const diaphragmValveComponent: FlowComponentDefinition = {
  type: "diaphragmValve",
  title: "diaphragm valve",
  category: "Valves",
  visualKind: "diaphragmValve",
  defaultColor: "#9ea4ab",
  previewFlow: { from: "left", to: "right" },
  ports: ["left", "right"],
  incomingDirections: ["left"],
  outgoingDirections: ["right"],
  defaults: { diameter: "100", kv: "50", opening: "100" },
  fields: [
    { key: "diameter", label: "Diameter" },
    { key: "kv", label: "Kv" },
    { key: "opening", label: "Opening %" },
    { key: "color", label: "Color", inputType: "color" },
  ],
  renderGraphic: (context) => {
    const transform = context.isHorizontal ? undefined : "rotate(90 50 50)";

    return (
      <g transform={transform}>
        <line x1="0" y1="50" x2="18" y2="50" stroke={OUTLINE_COLOR} strokeWidth="2.2" strokeLinecap="round" />
        <line x1="82" y1="50" x2="100" y2="50" stroke={OUTLINE_COLOR} strokeWidth="2.2" strokeLinecap="round" />
        <polygon points="18,24 18,76 50,50" fill={context.componentColor} stroke={OUTLINE_COLOR} strokeWidth="2.2" strokeLinejoin="round" />
        <polygon points="82,24 82,76 50,50" fill={context.componentColor} stroke={OUTLINE_COLOR} strokeWidth="2.2" strokeLinejoin="round" />
        <line x1="34" y1="30" x2="66" y2="30" stroke={OUTLINE_COLOR} strokeWidth="2.2" strokeLinecap="round" />
        <line x1="26" y1="50" x2="74" y2="50" stroke={OUTLINE_COLOR} strokeWidth="1.8" strokeLinecap="round" />
        {renderStraightArrow(context)}
      </g>
    );
  },
  renderAnimatedFlow: (context) => renderStraightPulse(context),
};
